export enum MediaInteractions {
  Resumed,
  Stopped,
}
